/* this is a copy of lib/cached-fetch.ts but without the nextjs context */
import apiFetch from 'lib/api-fetch';
import cache from 'lib/client-cache';

function getFromCache<T>(url: string): T | null {
  return cache.get(url);
}

function storeInCache<T>(url: string, data: T) {
  cache.setTransient(url, data);
}

export default async function cachedFetch<T>(url: string): Promise<T> {
  const cachedResponse = getFromCache<T>(url);
  if (cachedResponse) return cachedResponse;
  const response = await apiFetch<T>(null, url);
  storeInCache(url, response);
  return response;
}
